<template>
  <div class="customer-home"
    id="rootDom">
    <lead :pathOption="pathOption" :info_phone="info_phone"/>
    <navbar/>
    <main class="customer-main"
      :class="{moveUp: isMoveUp, moveDown: !isMoveUp}">
      <router-view
        ref="currentView"
        :pathOption="pathOption"
      />
    </main>
    <!-- <toTop /> -->
    <foote @emitInfoPhone="getInfoPhone"/>
  </div>

</template>

<script>
import store from "../../../store/index.js";
// 头部
import lead from "./head";
import navbar from "./navbar";
// 底部
import foote from "./foot";
// 回到顶部按钮
// import toTop from "./toTop";
export default {
  components: {
    lead,
    foote,
    navbar,
    // toTop
  },
  data() {
    return {
      isMoveUp: this.$route.name === "videodetail",
      carouselPicData: [], //轮播图数据
      pathOption: {
        // personal: "",//个人中心跳转路径
        manage: "", //后台跳转路径
      },
      info_phone:null
    };
  },
  created() {
    this.getUseInfo();
  },
  mounted() {
    // this.getBaseUrl();
  },
  methods: {
    getInfoPhone(info_phone) {
      this.info_phone = info_phone;
    },
    // 获取跳转路径（个人中心，后台）
    getBaseUrl() {
      let host = sessionStorage.getItem("host");
      let token = localStorage.getItem("token");
      let protocol = sessionStorage.getItem("protocol");
      if (token != "--") {
        this.pathOption.personal =
          protocol +
          "://" +
          host +
          "/personal/login?token=" +
          token +
          "?protocol=" +
          protocol +
          "&host=" +
          host;
        this.pathOption.manage =
          protocol +
          "://" +
          host +
          "/admin/login?token=" +
          token +
          "?protocol=" +
          protocol +
          "&host=" +
          host;
      } else {
        this.pathOption.personal =
          protocol +
          "://" +
          host +
          "/personal" +
          "?protocol=" +
          protocol +
          "&host=" +
          host;
        this.pathOption.manage =
          protocol +
          "://" +
          host +
          "/admin" +
          "?protocol=" +
          protocol +
          "&host=" +
          host;
      }
    },
    /**
     * 获取用户信息
     */
    getUseInfo() {
      const success = (res) => {
        let data = res.data;

        // 缓存获取到的用户信息
        sessionStorage.setItem("user_info_str", JSON.stringify(data.userinfo));
        sessionStorage.setItem("manage_url", data.manage_url);
        sessionStorage.setItem("ItcJwtToken", data.userinfo.ItcJwtToken);
        localStorage.setItem("token", data.token);
        store.commit("SET_USERINFO", data.userinfo);
        localStorage.setItem("userType",data.userinfo.type)
        this.$g.user_id = data.userinfo.id;
        this.getBaseUrl();
      };
      const fail = (err) => {
        localStorage.clear();
        sessionStorage.clear();
      };
      this.$ajax.get("api/login/login", {
        func: {
          success,
          fail,
        },
      });
    },
  },
};
</script>
<style lang="scss">
main {
  min-height: calc(100vh - 250px);
}
@import "../../../assets/css/homepage.scss";

// 分享按钮
.share-btn {
  margin-top: 10px;
  margin-right: 10px;
  height: 36px;
  color: #4477C3;
  border: none;

  img {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }
}

// 分享弹窗
.share_dialog {
  .el-dialog__header {
    background-color: #338efc;
    padding: 8px 20px 8px;

    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      top: 8px;
      right: 10px;

      .el-dialog__close {
        color: #fff;
        font-size: 24px;
      }
    }
  }

  .share_link {
    margin-bottom: 30px;
    line-height: 24px;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .copy_btn {
    display: block;
    margin: 0 auto;
  }
}
</style>
